import {
    animate,
    group,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import { AnimationCurves, AnimationDurations } from '@angular/material/core';

export const animationTranslateBottomTop = trigger('state', [
    state('void, hidden', style({ display: 'none' })),
    state(
        'showing',
        style({ display: 'absolute', transform: 'translateY(100%)' })
    ),
    state('visible', style({ display: 'absolute' })),
    transition('visible => void, visible => hidden', [
        animate(
            `0s ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ transform: 'translateY(0%)' })
        ),
        animate(
            `${AnimationDurations.ENTERING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ transform: 'translateY(100%)' })
        )
    ]),
    transition('hidden => showing', [
        animate(
            `0s ${AnimationCurves.ACCELERATION_CURVE}`,
            style({
                display: 'absolute'
            })
        )
    ]),
    transition('showing => visible', [
        animate(
            `0s ${AnimationCurves.ACCELERATION_CURVE}`,
            style({
                transform: 'translateY(100%)'
            })
        ),
        animate(
            `${AnimationDurations.ENTERING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ transform: 'translateY(0%)' })
        )
    ])
]);

export const animationOpacity = trigger('stateOpacity', [
    state('void, hidden', style({ display: 'none' })),
    state(
        'showing',
        style({
            display: '*',
            opacity: 0,
            flexDirection: '*'
        })
    ),
    state(
        'visible',
        style({
            display: '*',
            opacity: 1,
            flexDirection: '*'
        })
    ),
    transition('visible => void, visible => hidden', [
        animate(
            `${AnimationDurations.EXITING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ opacity: 0 })
        )
    ]),
    transition('showing => visible', [
        animate(
            `${AnimationDurations.ENTERING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({
                opacity: 1
            })
        )
    ])
]);

export const animationOpacityRow = trigger('stateOpacity', [
    state('void, hidden', style({ display: 'none' })),
    state(
        'showing',
        style({ display: 'flex', opacity: 0, flexDirection: 'column' })
    ),
    state(
        'visible',
        style({ display: 'flex', opacity: 1, flexDirection: 'column' })
    ),
    transition('visible => void, visible => hidden', [
        animate(
            `${AnimationDurations.EXITING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ opacity: 0 })
        )
    ]),
    transition('showing => visible', [
        animate(
            `${AnimationDurations.ENTERING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({
                opacity: 1
            })
        )
    ])
]);

export const animationOpacityFlex = trigger('stateOpacity', [
    state('void, hidden', style({ display: 'none' })),
    state('showing', style({ display: 'flex', opacity: 0 })),
    state('visible', style({ display: 'flex', opacity: 1 })),
    transition('visible => void, visible => hidden', [
        animate(
            `${AnimationDurations.EXITING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ opacity: 0 })
        )
    ]),
    transition('showing => visible', [
        animate(
            `${AnimationDurations.ENTERING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({
                opacity: 1
            })
        )
    ])
]);

export const showHideAnimation = trigger('showHide', [
    state('void, hidden', style({ opacity: 0 })),

    state('visible', style({ opacity: 1 })),
    transition('visible => void, visible => hidden', [
        animate(
            `${AnimationDurations.EXITING} ${AnimationCurves.ACCELERATION_CURVE}`,
            style({ opacity: 0 })
        )
    ]),
    transition('void => visible', [
        group([
            animate(
                `300ms ${AnimationCurves.ACCELERATION_CURVE}`,
                style({
                    opacity: 1
                })
            )
        ])
    ])
]);
